<a *ngIf="!navLink.external; else externalLink"
   [replaceUrl]="options.replaceUrl" [routerLink]="navLink?.link" [queryParams]="navLink?.queryParams || null"
   class="pw-nav-tab">
  <span translate>{{navLink.title}}</span>
  <span class="badge" *ngIf="!!badge || badge === 0">{{badge}}</span>
</a>

<ng-template #externalLink>
  <a [href]="navLink.link" class="pw-nav-tab" target="_blank">
    <span translate>{{navLink.title}}</span>
    <span class="badge" *ngIf="!!badge || badge === 0">{{badge}}</span>
  </a>
</ng-template>
